export default "__VITE_ASSET__1713b0cb__"